import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColumnHeader } from 'src/app/models/column-header';
import { SrcPath } from'src/app/constants/srcPath';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { isBlank, isData, setTableName, iconListOptions, iconStyleOptions, popupWidthClassOptions, isPresent } from 'src/app/utils/utils';
import { CommonService } from 'src/app/services/common-service/common.service';
import { Labels } from'src/app/constants/labels';
import { KEYS } from'src/app/constants/keys';
import { CommonModule, DatePipe } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';


@Component({
  selector: 'app-create-page',
  templateUrl: './create-page.component.html',
  styleUrls: ['./create-page.component.scss'],
  imports:[NgSelectComponent,FormsModule,CommonModule,ReactiveFormsModule,SharedModule]
})
export class CreatePageComponent implements OnInit {
  createPageForm: FormGroup | any;
  srcPath = SrcPath;
  labelMessages = Labels.messages;
  labelName = Labels.labels;
  labelPage = Labels.page;
  headerData: ColumnHeader | any;
  appPageList: any = [];
  iconListOption = iconListOptions;
  iconStyleOption = iconStyleOptions;
  popupWidthClassOption = popupWidthClassOptions
  submitted = false;
  dataBeforeEdit: any = [];
  isSuperaDmin: boolean = false;
  dbPath: any;
  tableList: any = [];
  menuListdata: any = [];
  moduleListdata: any = [];
  childMenuListdata: any = [];
  staticPageslist: any = [];
  menumoduleorderData: any = [];
  inputMode = '0';
  messageLabel = Labels.messages;

  constructor(private formBuilder: FormBuilder,
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService, private route: ActivatedRoute,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.isSuperAdmin();
    this.loadOrderMenuData(0);
    this.loadStaticMenu();
    this.submitted = false;
    this.initPageForm();
    this.LoadAllMenu();
    this.loadPageList();
    this.loadListDynamicTables();

    this.route.queryParams.subscribe(params => {
      if (isPresent(params['inputMode']) && params['inputMode'] == '1') {
        this.inputMode = '1';
      }
      const id = ((params['pageId'] == undefined) ? JSON.parse(params['pageDetails']).pgid : params['pageId']);
      this.initColumnHeader((params['pageId'] == undefined ? JSON.parse(params['pageDetails']).pgid : params['pageId']));
      if (id > 0) {
        const pageDetails = params['pageDetails'];
        if (pageDetails != null) {
          this.loadPage(JSON.parse(pageDetails));
        }
      }
      else {
        this.initColumnHeader(this.createPageForm.value.pageId);
        this.initPageForm();
      }
    });
  }
  isSuperAdmin() {
    const sessionSuperAdmin = sessionStorage.getItem(KEYS.isSuperAdmin);
    if (sessionSuperAdmin)
      this.isSuperaDmin = JSON.parse(sessionSuperAdmin);
    if (this.isSuperaDmin) {
      const sessionCustomerPath = sessionStorage.getItem(KEYS.customerDbPath);
      if (sessionCustomerPath)
        this.dbPath = JSON.parse(sessionCustomerPath);
    }
  }
  private initColumnHeader(pageID: any) {
    this.headerData = {
      title: this.labelPage.create_page,
      button: {
        show: false
      },
      topButton: {
        show: true,
        property: [
          {
            title: this.labelMessages.page_creation.page_save,
            icon: SrcPath.saveIcon,
            class: this.labelMessages.page_creation.page_class_back09
          },
          {
            title: this.labelMessages.page_creation.page_back,
            icon: SrcPath.previousIcon,
            class: this.labelMessages.page_creation.page_class_back11
          },
          {
            title: this.labelMessages.page_creation.page_audit,
            icon: SrcPath.auditTrailIcon,
            class: this.labelMessages.page_creation.page_class_back11,
            pageId: pageID,
            fromPage: 1
          }
        ]
      }
    };
  }
  onModuleChange() {
    this.childMenuListdata = this.menuListdata.filter((x: any) => x.gstibo_parent_menu_id == this.createPageForm.value.moduleId);
  }

  initPageForm() {
    this.createPageForm = this.formBuilder.group({
      pageId: KEYS.insertStatus.defaultID,
      pageName: ['', Validators.required],
      pageDesc: [''],
      pageIcon: [this.labelName.default_icon],
      pageBgColor: [''],
      pageIconStyle: ['back11'],
      linkPageId: [null],
      staticPageId: [null],
      isPagelinked: [KEYS.checkedStatus.unchecked],
      isStaticPagelinked: [KEYS.checkedStatus.unchecked],
      popupWidthClass: [null],
      isSameTable: [KEYS.checkedStatus.checked],
      pageTableName: [null],
      moduleId: [null],
      withMenuGroupId: [null],
      createWithMenu: [KEYS.checkedStatus.unchecked],
      parentMenuId: [null]
    });
  }
  loadPage(pageDetails: any) {
    if (isPresent(sessionStorage.getItem(KEYS.pageDetailsEdit))) {
      this.dataBeforeEdit = JSON.parse(sessionStorage.getItem(KEYS.pageDetailsEdit)!);

    }
    this.createPageForm = this.formBuilder.group({
      pageId: pageDetails['gstibo_page_id'],
      pageName: [pageDetails['gstibo_page_name'], Validators.required],
      pageDesc: [pageDetails['gstibo_app_description']],
      pageIcon: [(pageDetails['gstibo_icon'] == '' ? null : pageDetails['gstibo_icon'])],
      pageBgColor: [pageDetails['gstibo_bg_color']],
      pageIconStyle: [(pageDetails['gstibo_menu_style'] == '' ? null : pageDetails['gstibo_menu_style'])],
      linkPageId: [(pageDetails['gstibo_linked_page'] == 0 ? null : pageDetails['gstibo_linked_page'])],
      staticPageId: [(pageDetails['gstibo_linked_page_static'] == 0 ? null : pageDetails['gstibo_linked_page_static'])],
      isPagelinked: [(pageDetails['gstibo_linked_page'] == 0 ? KEYS.checkedStatus.unchecked : KEYS.checkedStatus.checked)],
      isStaticPagelinked: [(pageDetails['gstibo_linked_page_static'] == 0 ? KEYS.checkedStatus.unchecked : KEYS.checkedStatus.checked)],
      popupWidthClass: [pageDetails['gstibo_popup_width']],
      isSameTable: [(pageDetails['gstibo_is_same_page_table'] == 0 ? KEYS.checkedStatus.unchecked : KEYS.checkedStatus.checked)],
      pageTableName: [pageDetails['gstibo_table_name']],
      moduleId: ([pageDetails['moduleid'] > 0 ? pageDetails['moduleid'] : ((pageDetails['module_id'] == null) ? pageDetails['gstibo_with_menu_group_id'] : pageDetails['module_id'])]),
      withMenuGroupId: [((pageDetails['gstibo_with_menu_group_id'] == 0) ? null : pageDetails['gstibo_with_menu_group_id'])],
      createWithMenu: 0,
      parentMenuId: [null]
    });
  }
  onSubmit() {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.submitted = true;
    let inputLabel = '';
    let pageId = 0, ipaddress = '', machinename = '';
    this.commonService.ogLog('this.createPage.valid:', this.createPageForm.valid);
    if (this.createPageForm.valid) {
      if (this.createPageForm.value.pageId <= 0) {
        let tblName = '';
        if (this.createPageForm.value.isSameTable == 0) {
          tblName = this.createPageForm.value.pageTableName;
          this.commonService.createPage(
            dbFullPath,
            this.createPageForm.value.pageName,
            this.createPageForm.value.pageDesc,
            this.createPageForm.value.pageIcon,
            this.createPageForm.value.pageBgColor,
            (this.createPageForm.value.pageIconStyle == null ? '' : this.createPageForm.value.pageIconStyle),
            this.commonService.getUserCredentials(KEYS.credential_customer_id),
            tblName,
            (this.createPageForm.value.isPagelinked == KEYS.checkedStatus.checked ? (this.createPageForm.value.linkPageId == null ? KEYS.checkedStatus.unchecked : this.createPageForm.value.linkPageId) : KEYS.checkedStatus.unchecked),
            (this.createPageForm.value.isStaticPagelinked == KEYS.checkedStatus.checked ? (this.createPageForm.value.staticPageId == null ? KEYS.checkedStatus.unchecked : this.createPageForm.value.staticPageId) : KEYS.checkedStatus.unchecked),
            this.createPageForm.value.popupWidthClass, (this.createPageForm.value.isSameTable == false ? 0 : 1),
            (this.createPageForm.value.createWithMenu == false ? 0 : 1), this.createPageForm.value.withMenuGroupId, this.createPageForm.value.withMenuGroupId
          ).subscribe((mdata: any) => {
            if (isData(mdata)) {
              pageId = mdata['table'][0].id;
              this.createPageForm.patchValue({
                pageId: mdata['table'][0].id
              });
             // this.toastr.success(this.labelMessages.save_success_msg.message);
             this.commonService.showModalValidate(this.labelMessages.save_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.save_success_msg.message);
              let islinkedafter = (this.createPageForm.value.isPagelinked == '0' ? 'false' : 'true');
              let islinkedStatic = (this.createPageForm.value.isStaticPagelinked == '0' ? 'false' : 'true');
              inputLabel = "Page Name" + " ~~ " + this.createPageForm.value.pageName + "~~~" +
                "Description " + " ~~ " + this.createPageForm.value.pageDesc + "~~~" +
                "Icon " + " ~~ " + this.createPageForm.value.pageIcon + "~~~" +
                "BG Color " + " ~~ " + this.createPageForm.value.pageBgColor + "~~~" +
                "Icon Style " + " ~~ " + (this.createPageForm.value.pageIconStyle == null ? '' : this.createPageForm.value.pageIconStyle) + "~~~" +
                "Link Page " + " ~~ " + this.createPageForm.value.isPagelinked + "~~~" +
                "Link Page Id " + " ~~ " + this.createPageForm.value.linkPageId + "~~~" +
                "Show Static Data " + " ~~ " + this.createPageForm.value.isStaticPagelinked + "~~~" +
                "Static Page Id " + " ~~ " + this.createPageForm.value.staticPageId + "~~~" +
                "Created By" + " ~~ " + this.commonService.getUserCredentials(KEYS.credential_account_id) + "~~~" +
                "Created On" + " ~~ " + this.datePipe.transform(new Date(), 'MM-dd-yyyy');
              this.commonService.saveAuditTrialAdmin(dbFullPath, pageId, 0, 0, KEYS.saveType.INSERT, ipaddress, machinename,
                this.commonService.getUserCredentials(KEYS.credential_customer_id), inputLabel,
                this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe(auditdata => {
                },
                  error => {
                    console.log('generateAuditTrail Error:', error);
                  });
              this.initColumnHeader(this.createPageForm.value.pageId);
            }
          });
        }
        else {
          tblName = setTableName(this.createPageForm.value.pageName);
          this.commonService.saveTable(dbFullPath, tblName).subscribe((data: any) => {
            let isTableCreated = data['table'][0].success;
            if (isTableCreated) {
              this.commonService.createPage(
                dbFullPath,
                this.createPageForm.value.pageName,
                this.createPageForm.value.pageDesc,
                this.createPageForm.value.pageIcon,
                this.createPageForm.value.pageBgColor,
                (this.createPageForm.value.pageIconStyle == null ? '' : this.createPageForm.value.pageIconStyle),
                this.commonService.getUserCredentials(KEYS.credential_customer_id),
                tblName,
                (this.createPageForm.value.isPagelinked == KEYS.checkedStatus.checked ? (this.createPageForm.value.linkPageId == null ? KEYS.checkedStatus.unchecked : this.createPageForm.value.linkPageId) : KEYS.checkedStatus.unchecked),
                (this.createPageForm.value.isStaticPagelinked == KEYS.checkedStatus.checked ? (this.createPageForm.value.staticPageId == null ? KEYS.checkedStatus.unchecked : this.createPageForm.value.staticPageId) : KEYS.checkedStatus.unchecked),
                this.createPageForm.value.popupWidthClass, this.createPageForm.value.isSameTable,
                (this.createPageForm.value.createWithMenu == false ? 0 : 1), this.createPageForm.value.withMenuGroupId, this.createPageForm.value.withMenuGroupId
              ).subscribe((mdata: any) => {
                if (isData(mdata)) {
                  pageId = mdata['table'][0].id;
                  this.createPageForm.patchValue({
                    pageId: mdata['table'][0].id
                  });
                 // this.toastr.success(this.labelMessages.save_success_msg.message);
                 this.commonService.showModalValidate(this.labelMessages.save_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.save_success_msg.message);
                  let islinkedafter = (this.createPageForm.value.isPagelinked == '0' ? 'false' : 'true');
                  let islinkedStatic = (this.createPageForm.value.isStaticPagelinked == '0' ? 'false' : 'true');
                  inputLabel = "Page Name" + " ~~ " + this.createPageForm.value.pageName + "~~~" +
                    "Description " + " ~~ " + this.createPageForm.value.pageDesc + "~~~" +
                    "Icon " + " ~~ " + this.createPageForm.value.pageIcon + "~~~" +
                    "BG Color " + " ~~ " + this.createPageForm.value.pageBgColor + "~~~" +
                    "Icon Style " + " ~~ " + (this.createPageForm.value.pageIconStyle == null ? '' : this.createPageForm.value.pageIconStyle) + "~~~" +
                    "Link Page " + " ~~ " + this.createPageForm.value.isPagelinked + "~~~" +
                    "Link Page Id " + " ~~ " + this.createPageForm.value.linkPageId + "~~~" +
                    "Show Static Data " + " ~~ " + this.createPageForm.value.isStaticPagelinked + "~~~" +
                    "Static Page Id " + " ~~ " + this.createPageForm.value.staticPageId + "~~~" +
                    "Created By" + " ~~ " + this.commonService.getUserCredentials(KEYS.credential_account_id) + "~~~" +
                    "Created On" + " ~~ " + this.datePipe.transform(new Date(), 'MM-dd-yyyy');
                  this.commonService.saveAuditTrialAdmin(dbFullPath, pageId, 0, 0, KEYS.saveType.INSERT, ipaddress, machinename,
                    this.commonService.getUserCredentials(KEYS.credential_customer_id), inputLabel,
                    this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe(auditdata => {
                    },
                      error => {
                        console.log('generateAuditTrail Error:', error);
                      });
                  this.initColumnHeader(this.createPageForm.value.pageId);
                }
              });
            }
            else {
             // this.toastr.warning(this.labelMessages.page_creation.page_table_creation_error);
              this.commonService.showModalValidate(this.labelMessages.page_creation.page_table_creation_error,'',this.messageLabel.static_messages.warning,this.labelMessages.page_creation.page_table_creation_error);
            }
          });
        }


      } else {
        this.commonService.updatePage(
          dbFullPath,
          this.createPageForm.value.pageId,
          this.createPageForm.value.pageName,
          this.createPageForm.value.pageDesc,
          this.createPageForm.value.pageIcon,
          this.createPageForm.value.pageBgColor,
          (this.createPageForm.value.pageIconStyle == null ? '' : this.createPageForm.value.pageIconStyle),
          this.commonService.getUserCredentials(KEYS.credential_customer_id),
          (this.createPageForm.value.isPagelinked == KEYS.checkedStatus.checked ? (this.createPageForm.value.linkPageId == null ? KEYS.checkedStatus.unchecked : this.createPageForm.value.linkPageId) : KEYS.checkedStatus.unchecked),
          (this.createPageForm.value.isStaticPagelinked == KEYS.checkedStatus.checked ? (this.createPageForm.value.staticPageId == null ? KEYS.checkedStatus.unchecked : this.createPageForm.value.staticPageId) : KEYS.checkedStatus.unchecked),
          this.createPageForm.value.popupWidthClass, (isPresent(this.createPageForm.value.withMenuGroupId) ? this.createPageForm.value.withMenuGroupId : 0)
        ).subscribe((data: any) => {
          //this.toastr.success(this.labelMessages.update_success_msg.message);
           this.commonService.showModalValidate(this.labelMessages.update_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.update_success_msg.message);
          let updatedDetails = [];
          this.commonService.loadPageDetailsById(dbFullPath, this.createPageForm.value.pageId).subscribe((adata: any) => {
            isData(adata)
            {
              updatedDetails = adata['table'][0];
              this.dataBeforeEdit = JSON.parse(sessionStorage.getItem(KEYS.pageDetailsEdit)!);
              if (updatedDetails != null && this.dataBeforeEdit != null) {
                if (updatedDetails['gstibo_page_name'] != this.dataBeforeEdit['gstibo_page_name']) {
                  inputLabel += "Page Name" + " ~~ " + updatedDetails['gstibo_page_name'] + " ~ " + this.dataBeforeEdit['gstibo_page_name'] + " " + "~~~";
                }
                if (updatedDetails['gstibo_app_description'] != this.dataBeforeEdit['gstibo_app_description']) {
                  inputLabel += "Description" + " ~~ " + updatedDetails['gstibo_app_description'] + " ~ " + this.dataBeforeEdit['gstibo_app_description'] + " " + "~~~";
                }
                if (updatedDetails['gstibo_icon'] != this.dataBeforeEdit['gstibo_icon']) {
                  inputLabel += "Icon" + " ~~ " + updatedDetails['gstibo_icon'] + " ~ " + this.dataBeforeEdit['gstibo_icon'] + " " + "~~~";
                }
                if (updatedDetails['gstibo_bg_color'] != this.dataBeforeEdit['gstibo_bg_color']) {
                  inputLabel += "BG Color" + " ~~ " + updatedDetails['gstibo_bg_color'] + " ~ " + this.dataBeforeEdit['gstibo_bg_color'] + " " + "~~~";
                }
                if (updatedDetails['gstibo_menu_style'] != this.dataBeforeEdit['gstibo_menu_style']) {
                  inputLabel += "Icon Style" + " ~~ " + updatedDetails['gstibo_menu_style'] + " ~ " + this.dataBeforeEdit['gstibo_menu_style'] + " " + "~~~";
                }
                let islinkedafter = (updatedDetails['gstibo_linked_page'] == '0' ? 'false' : 'true');
                let islinkedbefore = (this.dataBeforeEdit['gstibo_linked_page'] == '0' ? 'false' : 'true');
                if (updatedDetails['gstibo_linked_page'] != this.dataBeforeEdit['gstibo_linked_page']) {
                  inputLabel += "Link Page" + " ~~ " + islinkedafter + " ~ " + islinkedbefore + " " + "~~~";
                }
                if (updatedDetails['linked_page_name'] != this.dataBeforeEdit['linked_page_name']) {
                  inputLabel += "Linked Page Name" + " ~~ " + updatedDetails['linked_page_name'] + " ~ " + this.dataBeforeEdit['linked_page_name'] + " " + "~~~";
                }
                let islinkedafterstatic = (updatedDetails['gstibo_linked_page_static'] == '0' ? 'false' : 'true');
                let islinkedbeforestatic = (this.dataBeforeEdit['gstibo_linked_page_static'] == '0' ? 'false' : 'true');
                if (updatedDetails['gstibo_linked_page_static'] != this.dataBeforeEdit['gstibo_linked_page_static']) {
                  inputLabel += "Show Static Data" + " ~~ " + islinkedafterstatic + " ~ " + islinkedbeforestatic + " " + "~~~";
                }
                if (updatedDetails['linked_page_static_name'] != this.dataBeforeEdit['linked_page_static_name']) {
                  inputLabel += "Static Page Name" + " ~~ " + updatedDetails['linked_page_static_name'] + " ~ " + this.dataBeforeEdit['linked_page_static_name'] + " " + "~~~";
                }
                inputLabel += "Updated By" + " ~~ " + this.commonService.getUserCredentials(KEYS.credential_account_id) + "~~~" +
                  "Updated On" + " ~~ " + this.datePipe.transform(new Date(), 'MM-dd-yyyy');
                this.commonService.saveAuditTrialAdmin(dbFullPath, this.createPageForm.value.pageId, 0, 0, KEYS.saveType.UPDATE, ipaddress, machinename,
                  this.commonService.getUserCredentials(KEYS.credential_customer_id), inputLabel,
                  this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe(auditdata => {
                  },
                    error => {
                      console.log('generateAuditTrail Error:', error);
                    });
              }
            }
          });
        });
      }
    }
    else {
      if (isBlank(this.createPageForm.value.pageName)) {
        //this.toastr.warning(this.labelMessages.page_creation.page_name);
        this.commonService.showModalValidate(this.labelMessages.page_creation.page_name,'',this.messageLabel.static_messages.warning,this.labelMessages.page_creation.page_name);
      }
    }
  }
  loadPageList() {
    this.appPageList = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadPageList(dbFullPath).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      if (isData(data)) {
        data['table'].forEach((element: any) => {
          this.appPageList.push({
            'pageId': element.gstibo_page_id,
            'pageName': element.gstibo_page_name,
            'tableName': element.gstibo_table_name
          });
        });
      }
    });
  }
  loadListDynamicTables() {
    this.tableList = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.getListDynamicTables(dbFullPath).subscribe((data: any) => {
      if (isData(data)) {
        data['table'].forEach((element: any) => {
          this.tableList.push({
            'tableName': element.gstibo_table_name
          });
        });
      }
    });
  }

  get f() { return this.createPageForm.controls; }

  LoadAllMenu() {
    this.menuListdata = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadMenu(dbFullPath, this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data: any) => {
      if (isData(data)) {
        this.menuListdata = data['table'];
        this.moduleListdata = data['table'].filter((x: any) => x.gstibo_parent_menu_id == 0);
        let parentmenus = this.staticPageslist.filter((p: any) => p.gstibo_is_show_parentmodule_Id == 0)
        parentmenus.forEach((element: any) => {
          this.moduleListdata.push({
            'gstibo_menu_name': element.gstibo_menu_name,
            'gstibo_page_name': element.gstibo_menu_name,
            'gstibo_menu_id': element.gstibo_menu_id,
            'moduleid': element.gstibo_menu_id,
            'gstibo_icon': 'timesheet',
            'pgid': element.gstibo_page_id,
            'pagetype': 'S',
            'gstibo_with_menu_group_id': element.gstibo_menu_id
          })

        });
        if (isPresent(this.createPageForm.value.pageId) && this.createPageForm.value.pageId > 0) {
          this.onModuleChange();
        }
        this.commonService.ogLog("menuListdata", this.menuListdata);
      } else {
        this.commonService.ogLog('data not available');
      }
    },
      error => {
        console.log('executeLogicAppsApi Error:', error);
      });
  }

  loadStaticMenu() {

    let userAccountID = this.commonService.getUserCredentials(KEYS.credential_customer_id);
    this.commonService.loadStaticMenuForUser(userAccountID).subscribe((data: any) => {
      if (isData(data)) {
        this.staticPageslist = [];
        this.staticPageslist = data['table'];
      }
    });
  }
  loadOrderMenuData(menuid: any) {
    this.commonService.getModulemenuorderlist(menuid).subscribe((data: any) => {
      if (isData(data)) {
        // if(this.menumoduleorderData.length ==0)
        // {
        this.menumoduleorderData = data['table'];
        // }
      }
    });
  }
}
